(function () {
    "use strict";
    document.querySelectorAll(".product-availability").forEach(function (container, widgetIndex) {
        var months = Array.from(container.querySelectorAll(".availability-month"));
        if (!months.length) return;
        var controls = container.querySelector(".availability-controls");
        var select = controls.querySelector("select");
        var previous = controls.querySelector('[data-direction="-1"]');
        var next = controls.querySelector('[data-direction="1"]');
        var count = container.querySelector(".availability-count");
        var locations = Array.from(container.querySelectorAll(".availability-location"));
        if (new Set(locations.map(function (location) { return location.textContent; })).size === 1) {
            locations.forEach(function (location) { location.hidden = true; });
        }
        var details = document.createElement("section");
        details.className = "availability-details";
        details.id = "availability-details-" + widgetIndex;
        details.hidden = true;
        var detailsHeading = document.createElement("h3");
        detailsHeading.id = details.id + "-heading";
        detailsHeading.tabIndex = -1;
        details.setAttribute("aria-labelledby", detailsHeading.id);
        var close = document.createElement("button");
        close.type = "button";
        close.className = "availability-details-close";
        close.textContent = "Close";
        close.setAttribute("aria-label", "Close departure times");
        var detailsTimes = document.createElement("ul");
        detailsTimes.className = "availability-times";
        details.append(detailsHeading, close, detailsTimes);
        months[months.length - 1].after(details);
        var activeMore = null;
        function closeDetails(restoreFocus) {
            details.hidden = true;
            if (activeMore) {
                activeMore.setAttribute("aria-expanded", "false");
                activeMore.closest("td").classList.remove("availability-selected");
                if (restoreFocus) activeMore.focus();
                activeMore = null;
            }
        }
        close.addEventListener("click", function () { closeDetails(true); });
        details.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
                event.preventDefault();
                closeDetails(true);
            }
        });
        function limitTimes(cell, sessions, dateLabel) {
            var items = Array.from(sessions.children);
            if (items.length <= 2) return;
            items.slice(2).forEach(function (item) { item.hidden = true; });
            var more = document.createElement("button");
            more.type = "button";
            more.className = "availability-more";
            var remaining = items.length - 2;
            more.textContent = "+" + remaining + (remaining === 1 ? " more time" : " more times");
            more.setAttribute("aria-label", "Show all " + items.length + " departure times for " + dateLabel);
            more.setAttribute("aria-controls", details.id);
            more.setAttribute("aria-expanded", "false");
            more.addEventListener("click", function () {
                if (activeMore === more) { closeDetails(true); return; }
                closeDetails(false);
                activeMore = more;
                more.setAttribute("aria-expanded", "true");
                cell.classList.add("availability-selected");
                detailsHeading.textContent = dateLabel + " — departure times";
                detailsTimes.replaceChildren();
                items.forEach(function (item) {
                    var copy = item.cloneNode(true);
                    copy.hidden = false;
                    detailsTimes.appendChild(copy);
                });
                details.hidden = false;
                detailsHeading.focus({ preventScroll: true });
                details.scrollIntoView({ block: "nearest" });
            });
            cell.appendChild(more);
        }
        months.forEach(function (month, index) {
            var heading = month.querySelector("h3");
            select.add(new Option(heading.textContent, String(index)));
            heading.hidden = true;
            var days = month.querySelector(".availability-days");
            var entries = new Map();
            days.querySelectorAll(".availability-day").forEach(function (entry) {
                entries.set(Number(entry.querySelector("time").dateTime.slice(8)), entry);
            });
            month.dataset.dateCount = String(entries.size);
            var parts = month.dataset.month.split("-").map(Number);
            var year = parts[0];
            var monthNumber = parts[1] - 1;
            var offset = new Date(year, monthNumber, 1).getDay();
            var daysInMonth = new Date(year, monthNumber + 1, 0).getDate();
            var cellCount = Math.ceil((offset + daysInMonth) / 7) * 7;
            var table = document.createElement("table");
            table.className = "availability-calendar";
            table.setAttribute("aria-label", heading.textContent + " listed dates and departure times");
            var header = table.createTHead().insertRow();
            ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].forEach(function (name) {
                var th = document.createElement("th");
                th.scope = "col";
                var abbreviated = document.createElement("abbr");
                abbreviated.title = name;
                abbreviated.textContent = name.slice(0, 3);
                th.appendChild(abbreviated);
                header.appendChild(th);
            });
            var body = table.createTBody();
            var row;
            for (var cellIndex = 0; cellIndex < cellCount; cellIndex++) {
                if (cellIndex % 7 === 0) row = body.insertRow();
                var cell = row.insertCell();
                var dayNumber = cellIndex - offset + 1;
                var date = new Date(year, monthNumber, dayNumber);
                var outsideMonth = dayNumber < 1 || dayNumber > daysInMonth;
                var time = document.createElement("time");
                time.dateTime = date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0") + "-" + String(date.getDate()).padStart(2, "0");
                time.textContent = String(date.getDate());
                if (outsideMonth && (cellIndex === 0 || dayNumber === daysInMonth + 1)) {
                    time.textContent += " " + date.toLocaleDateString("en-AU", { month: "short" });
                }
                time.setAttribute("aria-label", date.toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long", year: "numeric" }));
                cell.appendChild(time);
                if (outsideMonth) {
                    cell.className = "availability-outside";
                } else if (entries.has(dayNumber)) {
                    cell.className = "availability-listed";
                    var sessions = entries.get(dayNumber).querySelector(".availability-times");
                    sessions.querySelectorAll("li > span:first-child").forEach(function (session) {
                        if (!session.textContent.trim()) session.textContent = "Available";
                    });
                    cell.appendChild(sessions);
                    limitTimes(cell, sessions, time.getAttribute("aria-label"));
                }
            }
            days.replaceWith(table);
        });
        function showMonth(index) {
            closeDetails(false);
            months.forEach(function (month, monthIndex) { month.hidden = monthIndex !== index; });
            select.value = String(index);
            previous.disabled = index === 0;
            next.disabled = index === months.length - 1;
            var dates = Number(months[index].dataset.dateCount);
            count.textContent = dates + (dates === 1 ? " date listed in " : " dates listed in ") + select.options[index].text;
        }
        select.addEventListener("change", function () { showMonth(Number(select.value)); });
        previous.addEventListener("click", function () { showMonth(Math.max(0, Number(select.value) - 1)); });
        next.addEventListener("click", function () { showMonth(Math.min(months.length - 1, Number(select.value) + 1)); });
        showMonth(0);
        controls.hidden = false;
    });
}());
